<template>
  <div class="ProvinceTable">
    <my_table :infos="infos" :titles="titles" :details="details"></my_table>
  </div>
</template>

<script>
 import MyTable from '@/components/TableWithDesc.vue'
 export default {
   name: '',
   computed: {
     titles() {
       return this.$store.state.aboutus.ptable.titles
     },
     infos() {
       return this.$store.state.aboutus.ptable.infos
     },
     details () {
       return this.$store.state.aboutus.ptable.details
     }
   },
   components: {
     my_table: MyTable
   }

 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
